<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
    data(){
      return{
          siteInfo: {},
      }
    },
    metaInfo(){
        return {
            title: this.siteInfo.title,
            // titleTemplate: '%s - by vue-meta',
            htmlAttrs: {
                lang: 'zh'
            },
            meta: [
                {name: 'Description', content: this.siteInfo.description},
                {name: 'keywords', content: this.siteInfo.keywords}
            ]
        }
    },
    mounted(){
        this.$GetSiteInfo({ type: 2 }).then(() => {
            this.siteInfo = this.$store.state.siteInfoData;
        })
    },
  components: {
      Header,
      Footer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
